function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x2: 1.037,
  y2: 1.356,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff3067"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a5119f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fffcfd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff80a2"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5008",
  "data-name": "Group 5008",
  transform: "translate(-705.511 -411.033)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4756",
  "data-name": "Group 4756",
  transform: "translate(706 411)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4701",
  "data-name": "Group 4701"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_36",
  "data-name": "Rectangle 36",
  width: 63,
  height: 110,
  rx: 7,
  transform: "translate(-0.489 0.033)",
  fill: "url(#linear-gradient)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4749",
  "data-name": "Group 4749",
  transform: "translate(728.512 506.229)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4750",
  "data-name": "Group 4750"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_15",
  "data-name": "Ellipse 15",
  cx: 1.825,
  cy: 1.825,
  r: 1.825,
  fill: "#fff9fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4751",
  "data-name": "Group 4751",
  transform: "translate(6.449)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_16",
  "data-name": "Ellipse 16",
  cx: 1.825,
  cy: 1.825,
  r: 1.825,
  fill: "#fff9fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4752",
  "data-name": "Group 4752",
  transform: "translate(12.898)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_17",
  "data-name": "Ellipse 17",
  cx: 1.825,
  cy: 1.825,
  r: 1.825,
  fill: "#fff9fb"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4755",
  "data-name": "Group 4755",
  transform: "translate(721.512 419.534)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4750-2",
  "data-name": "Group 4750",
  transform: "translate(22.105 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3556",
  "data-name": "Path 3556",
  d: "M238.553,42.431h-5.645a1.3,1.3,0,0,1,0-2.606h5.645a1.3,1.3,0,0,1,0,2.606Z",
  transform: "translate(-231.605 -39.825)",
  fill: "#fff9fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4751-2",
  "data-name": "Group 4751",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3557",
  "data-name": "Path 3557",
  d: "M121.13,42.431H105.712a1.3,1.3,0,1,1,0-2.606H121.13a1.3,1.3,0,1,1,0,2.606Z",
  transform: "translate(-104.409 -39.825)",
  fill: "#fff9fb"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4762",
  "data-name": "Group 4762",
  transform: "translate(0 5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4759",
  "data-name": "Group 4759",
  transform: "translate(721.511 475.535)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4750-3",
  "data-name": "Group 4750",
  transform: "translate(22.105 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3556-2",
  "data-name": "Path 3556",
  d: "M238.553,42.431h-5.645a1.3,1.3,0,0,1,0-2.606h5.645a1.3,1.3,0,0,1,0,2.606Z",
  transform: "translate(-231.605 -39.825)",
  fill: "#fff9fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4751-3",
  "data-name": "Group 4751",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3557-2",
  "data-name": "Path 3557",
  d: "M121.13,42.431H105.712a1.3,1.3,0,1,1,0-2.606H121.13a1.3,1.3,0,1,1,0,2.606Z",
  transform: "translate(-104.409 -39.825)",
  fill: "#fff9fb"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4760",
  "data-name": "Group 4760",
  transform: "translate(721.511 482.535)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4750-4",
  "data-name": "Group 4750",
  transform: "translate(22.105 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3556-3",
  "data-name": "Path 3556",
  d: "M238.553,42.431h-5.645a1.3,1.3,0,0,1,0-2.606h5.645a1.3,1.3,0,0,1,0,2.606Z",
  transform: "translate(-231.605 -39.825)",
  fill: "#fff9fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4751-4",
  "data-name": "Group 4751",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3557-3",
  "data-name": "Path 3557",
  d: "M121.13,42.431H105.712a1.3,1.3,0,1,1,0-2.606H121.13a1.3,1.3,0,1,1,0,2.606Z",
  transform: "translate(-104.409 -39.825)",
  fill: "#fff9fb"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4761",
  "data-name": "Group 4761",
  transform: "translate(721.511 489.535)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4750-5",
  "data-name": "Group 4750",
  transform: "translate(22.105 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3556-4",
  "data-name": "Path 3556",
  d: "M238.553,42.431h-5.645a1.3,1.3,0,0,1,0-2.606h5.645a1.3,1.3,0,0,1,0,2.606Z",
  transform: "translate(-231.605 -39.825)",
  fill: "#fff9fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4751-5",
  "data-name": "Group 4751",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3557-4",
  "data-name": "Path 3557",
  d: "M121.13,42.431H105.712a1.3,1.3,0,1,1,0-2.606H121.13a1.3,1.3,0,1,1,0,2.606Z",
  transform: "translate(-104.409 -39.825)",
  fill: "#fff9fb"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4754",
  "data-name": "Group 4754",
  transform: "translate(713.512 427.121)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4748",
  "data-name": "Group 4748",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3555",
  "data-name": "Path 3555",
  d: "M150.745,129.338h-1.784L121.3,126.823l-15.9-6.206V88.428a1.814,1.814,0,0,1,1.713-1.9h43.628a1.814,1.814,0,0,1,1.713,1.9v39.009A1.814,1.814,0,0,1,150.745,129.338Z",
  transform: "translate(-105.404 -86.527)",
  fill: "url(#linear-gradient-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4752-2",
  "data-name": "Group 4752",
  transform: "translate(0 21.706)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3558",
  "data-name": "Path 3558",
  d: "M107.129,194.794h42.206l-16.516-14.616a1.89,1.89,0,0,0-2.442,0l-3.623,3.206a.945.945,0,0,1-1.221,0l-10.45-9.248a1.89,1.89,0,0,0-2.442,0l-7.238,6.4v12.724A1.637,1.637,0,0,0,107.129,194.794Z",
  transform: "translate(-105.402 -173.689)",
  fill: "#fc2f69"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4753",
  "data-name": "Group 4753",
  transform: "translate(31.68 10.289)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_18",
  "data-name": "Ellipse 18",
  cx: 2.913,
  cy: 2.913,
  r: 2.913,
  fill: "#fc2f69"
}))));

function SvgUnactiveStoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63,
    height: 110,
    viewBox: "0 0 63 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnactiveStoryIcon);
export default __webpack_public_path__ + "static/media/unactive-story-icon.896359bd.svg";
export { ForwardRef as ReactComponent };